const config = require("../config")

module.exports = {
    fetchSpecieList: {
        url: config.base_dev_url + "container/specieList",
        type: "get",
    },
    saveFarm: {
        url: config.base_dev_url + "v2/farm/createFarm",
        type: "post",
    },
    userFarmSelectOption: {
        url: config.base_dev_url + "v2/farm/userFarmSelectOption",
        type: "get",
    },
    fruitsTypeItemList: {
        url: config.base_dev_url + "mini_fruits_type_item/list/{parentId}",
        type: "get",
    },
    getFarmDetail: {
        url: config.base_dev_url + "v2/farm/getFarmDetail",
        type: "get",
    },
    getFarmWorkLib: {
        url: config.base_dev_url + "z_farm_work_lib/get",
        type: "get",
    },
    //查询单个农事编排信息
    getFarmWorkArrangeDetail: {
        url: config.base_dev_url + "container_farm_work_arrange/get",
        type: "get",
    },
    // 生育期
    listByPhenologyId: {
        url: config.base_dev_url + "container_reproductive/listByPhenologyId",
        type: "get",
    },
    // 基地类别列表
    fetchBaseTypeList: {
        url: config.base_dev_url + "v2/farm/farmBaseTypeOptions",
        type: "get",
    },
    //获取作物品类列表
    findCategoryList: {
        url: config.base_new_url + "find_categoly",
        type: "get",
    },
    //新建农场
    createFarm: {
        url: config.base_new_url + "farm_information_create",
        type: "post",
    },
    //获取农场列表
    getFarmList: {
        url: config.base_new_url + "find_farm_information",
        type: "get",
    },
    //分区状态显示
    getRegionRecord: {
        url: config.base_new_url + "region_record",
        type: "get",
    },
    //农事详情查询
    getRegionWorkDetail: {
        url: config.base_new_url + "find_region_work",
        type: "get",
    },
}
